import React from 'react';
import { themeObject } from 'lib';

export interface InfoCardListProps {
    children: React.ReactNode;
}

export interface CtaData {
    icon: string;
    text: string;
}

export interface CardDataItem {
    title: string;
    description: string;
    cta?: CtaData;
}

export const infoCardListStyles = {
    containerGrid: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    childGrid: {
        mb: { xs: 4, md: 0 },
        display: 'flex',
    },
    infoCardButton: {
        fontWeight: 700,
        color: themeObject.palette.primary[700],
    },
    infoCardIcon: {
        color: themeObject.palette.primary[400],
    },
};
